<template>
  <el-button type="primary" class="cateBtn" @click="drawer = true">
    分类
  </el-button>

  <el-drawer v-model="drawer" title="I am the title" :with-header="false">
    <span>全部分类</span>
    <br>
    <el-button class="cateBtn" type="info" @click="selectCate('0')" plain>
        <img src="https://leejiall.oss-cn-beijing.aliyuncs.com/mirco/img/options/recommend-cate.png" alt="" style="width: 30px">
        推荐
    </el-button>
    <el-button class="cateBtn" type="info" plain v-for="cate in cateList" :key="cate.cateId" @click="selectCate(cate.cateId)">
        <img :src="cate.cateImg" alt="" style="width: 30px">
        {{ cate.cateName }}
    </el-button>
  </el-drawer>
</template>

<script setup>
import { ref,onMounted,defineEmits } from 'vue'
import $ from 'jquery';
const drawer = ref(false)
const cateList = ref([]);

const emit = defineEmits(["selectCate"]);

onMounted(() => {
    getAllCate();
});

const getAllCate = () => {
    $.ajax({
        url: "http://124.222.105.205:5000/get/api/cate/getAllCate",
        type: "post",
        success(resp) {
            cateList.value = resp.data;
            
        },
        error() {
        },
    });
}

const selectCate = (id) => {
  drawer.value = false;
  emit('selectCate', id);
}
</script>

<style scoped>
.cateBtn{
    margin: 5px;
}
</style>